import React, { FC } from 'react';
import Styles from './StaticProductEntitle.module.scss';
import { countZero, replacePlaceholder } from '../../utils/utils';
import SkeletonLoader from '../SkeletonLoader/SkeletonLoader';
import { DynamicPriceSchema } from './StaticProductDatatypes';
import ToolTip from '../ToolTip/ToolTip';
import RichText from '../richtext';

const DynamicPriceSection: FC<DynamicPriceSchema> = ({
  priceCollection,
  constants,
  promoText,
  deviceFlow,
  content,
  offeringData,
  uniqueId
}) => {
  const unit: string = 'CHF';
  const base: number = priceCollection?.base ?? 0;
  let discount = priceCollection?.discount?.[0]?.value ?? 0;
  let loyaltyPrice = priceCollection?.loyaltyPrice !== '' ? priceCollection?.loyaltyPrice : 0;
  const promoCycle: any = priceCollection?.discount;

  const productId = content?.products?.[0]?.reference?.content?.product?.[0]?.productId;
  const productData: any = (offeringData?.[uniqueId] || []).filter(
    (product: any) => product?.id === productId
  );
  const campaignDuration: any = productData?.[0]?.promotionInfo?.[0]?.campaignDuration ?? 0;
  const loyaltyMonths = campaignDuration || promoCycle?.[0]?.cycleEnd;
  const loyaltyDescription =
    content?.loyaltyTooltip?.[0]?.description &&
    replacePlaceholder(JSON.stringify(content?.loyaltyTooltip?.[0]?.description), [loyaltyMonths]);
  const loyaltyDescriptionContent = loyaltyDescription && JSON.parse(loyaltyDescription);

  priceCollection?.discount?.map((item: any) => {
    if (item?.cycleStart == 1) {
      discount = item?.value;
    }
  });

  const int_fmc = priceCollection?.int_fmc;
  const mob_fmc = priceCollection?.mob_fmc;
  const lifeTime = promoCycle?.some((cycle: any) => cycle?.cycleEnd === 720) ?? false;

  const priceContent = () => (
    <div>
      {/* Rendering text if configured for individual products separately in case of loyalty discount */}
      {loyaltyPrice > 0 && content?.loyaltyText ? (
        <div className={`${Styles.descText} ${Styles.loyaltyTextSection}`}>
          <div>
            {replacePlaceholder(content?.loyaltyText, [
              promoCycle?.[0]?.cycleEnd,
              countZero(base - priceCollection?.loyaltyPrice)
            ])}
          </div>
          {content?.loyaltyTooltip?.length > 0 && renderTooltip()}
        </div>
      ) : (
        <div className={Styles.pricedisplay}>
          {promoCycle.length > 0 &&
            promoCycle.map((cycle: any) => {
              return (
                <>
                  {' '}
                  <span className={Styles.pricelabel}>
                    {lifeTime ? (
                      <span> {constants?.lifetimeLabel} </span>
                    ) : (
                      <>
                        {' '}
                        {cycle.cycleStart != 1 && (
                          <>
                            {unit} {countZero(cycle.value)}
                          </>
                        )}{' '}
                        {cycle.cycleStart === 1
                          ? replacePlaceholder(constants?.promoFirstLt, [cycle.cycleEnd])
                          : replacePlaceholder(constants?.promoNextLt, [
                              cycle.cycleEnd - cycle.cycleStart + 1
                            ])}
                      </>
                    )}
                  </span>
                </>
              );
            })}
          {/* Showing tooltip only when there is loyalty price */}
          {!lifeTime && (
            <div className={Styles.descText}>
              <span>
                {replacePlaceholder(constants?.promoThenIt, [countZero(base - loyaltyPrice)])}
              </span>
              {loyaltyPrice > 0 && content?.loyaltyTooltip?.length > 0 && renderTooltip()}
            </div>
          )}
        </div>
      )}
    </div>
  );

  const renderTooltip = () => {
    return (
      <ToolTip
        content={loyaltyDescriptionContent && <RichText content={loyaltyDescriptionContent} />}
        heading={
          content?.loyaltyTooltip?.[0]?.title &&
          replacePlaceholder(content?.loyaltyTooltip?.[0]?.title, [
            countZero(base - priceCollection?.loyaltyPrice),
            constants?.month
          ])
        }
      />
    );
  };

  return (
    <div>
      {Number(base) >= 0 ? (
        // displaying price section without promotion
        deviceFlow?.noPromoToggle ? (
          <>
            <div className={`${Styles.pricecontainer}`}>
              <span className={`${Styles.discountedprice}`}>{countZero(base)}</span>
              <span className={`${Styles.duration}`}>{constants?.month}</span>
            </div>
          </>
        ) : (
          <>
            <div className={`${Styles.pricecontainer}`}>
              <span
                className={`${Styles.discountedprice} ${
                  int_fmc > 0 || mob_fmc > 0 || promoCycle?.length > 0 ? Styles.promo : ''
                }`}
              >
                {discount > 0 ? countZero(discount) : countZero(base)}
                <span className={`${Styles.duration}`}>{constants?.month}</span>
              </span>
              {base && (int_fmc > 0 || mob_fmc > 0 || promoCycle.length > 0) && (
                <span className={`${Styles.basePriceAfterDiscount}`}>{countZero(base)}</span>
              )}
              {!lifeTime && promoText && <div>{promoText}</div>}
            </div>

            {!mob_fmc &&
              !int_fmc &&
              promoCycle?.length > 0 &&
              promoCycle?.[0]?.cycleEnd &&
              priceContent()}
          </>
        )
      ) : (
        <SkeletonLoader stylename={Styles.blockskeleton} />
      )}
    </div>
  );
};
export default DynamicPriceSection;
